import React from "react";
import classes from "./FooterLinks.module.css";
import FooterLink from "./FooterLink/FooterLink";

const links = [
  {
    label: "email",
    title: "Email",
    link: "mailto:hello@afeedhshaji.in"
  },
  {
    label: "bluesky",
    title: "@hey.pds.afeedhshaji.in",
    link: "https://bsky.app/profile/hey.pds.afeedhshaji.in"
  }
];

const footerLinks = () => {
  return (
    <div className={classes.footer__links}>
      {links.map(linkKey => (
        <FooterLink
          title={linkKey.title}
          link={linkKey.link}
          label={linkKey.label}
          key={linkKey.label}
        />
      ))}
    </div>
  );
};

export default footerLinks;
